import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsConverterService, defaultFSCatalog } from '../../../services/cms-converter/cms-converter.service'
import { ConvertedComponentData, FsCatalog } from '../../types'

@Injectable({ providedIn: 'root' })
export class TeaserSliderContainerConverter extends CmsConverterService<TeaserSliderContainerData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      items: formData?.st_items ?? defaultFSCatalog,
      fullWidth: formData?.st_full_width?.value ?? false,
      promotionTracking: formData.st_promotion_tracking?.value?.identifier ?? true
    }
  }
}

export const TEASER_SLIDER_CONTAINER_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TeaserSliderContainerData>>('TeaserSliderContainerConverter')

export interface TeaserSliderContainerData extends ConvertedComponentData {
  items: FsCatalog;
  fullWidth: boolean;
  promotionTracking: boolean;
}
